export const ROLES = {
  ADMIN: 'Admin',
  TEAM_ADMIN: 'Team Admin',
  USER: 'User',
} as const;

export type Role = (typeof ROLES)[keyof typeof ROLES];
